import DbService from 'resources/db.service';
import schema from './milestone.schema';

const service = new DbService('milestones', { schema });

const createMilestone = async ({
  id,
  companyId,
  name,
  type,
  dueInDays,
  dueRelativeDate,
  isAfterAction,
  editable,
  status,
  dealId,
}) => {
  const milestoneResult = await service.create({
    ...(id && { id }),
    company_id: companyId,
    name,
    type,
    ...(dueInDays !== null && dueInDays !== undefined && { due_in_days: dueInDays }),
    ...(dueRelativeDate && { due_relative_date: dueRelativeDate }),
    is_after_action: !!isAfterAction,
    editable,
    status,
    ...(dealId && { deal_id: dealId }),
  });

  return milestoneResult.data[0];
};

const getMilestoneById = async (id) => {
  let response = await service.selectByKey({
    selectKey: 'getMilestoneById',
    params: { id },
  });

  response = service.processResponse(response);
  return response?.data?.[0];
};

const getMilestonesByIds = async (milestoneIds) => {
  let response = await service.selectByKey({
    selectKey: 'getMilestonesByIds',
    params: { milestoneIds },
  });

  response = service.processResponse(response);
  return response?.data;
};

const getPreContractMilestonesByDealId = async (dealId) => {
  // let response = await service
  //   .select()
  //   .not('deal_id', 'is', null)
  //   .match({ deal_id: dealId, type: MILESTONE_TYPES.PRE_CONTRACT })
  //   .select(`
  //     *,
  //     deal:deal_id (*)
  //   `)
  //   .order('created_on');

  let response = await service.publicSelectByKey({
    selectKey: 'getPreContractMilestonesByDealId',
    params: { dealId },
  });

  response = service.processResponse(response);

  return response?.data;
};

const getUnderContractMilestonesByDealId = async (dealId) => {
  // let response = await service
  //   .select()
  //   .not('deal_id', 'is', null)
  //   .match({ deal_id: dealId, type: MILESTONE_TYPES.UNDER_CONTRACT })
  //   .order('created_on');

  let response = await service.publicSelectByKey({
    selectKey: 'getUnderContractMilestonesByDealId',
    params: { dealId },
  });

  response = service.processResponse(response);

  return response?.data;
};

const getAfterCloseMilestonesByDealId = async (dealId) => {
  // let response = await service
  //   .select()
  //   .not('deal_id', 'is', null)
  //   .match({ deal_id: dealId, type: MILESTONE_TYPES.AFTER_CLOSE })
  //   .order('created_on');

  let response = await service.publicSelectByKey({
    selectKey: 'getAfterCloseMilestonesByDealId',
    params: { dealId },
  });

  response = service.processResponse(response);

  return response?.data;
};

const getMilestonesByDealId = async (dealId) => {
  const data = await service.find({ deal_id: dealId });
  return data;
};

const getMilestonesByDealIds = async (dealIds) => {
  // let response = await service
  //   .select()
  //   .in('deal_id', dealIds);

  let response = await service.selectByKey({
    selectKey: 'getMilestonesByDealIds',
    params: { dealIds },
  });

  response = service.processResponse(response);

  return response?.data;
};

const getAllKitsMilestones = async (companyId) => {
  // let response = await service
  //   .select()
  //   .eq('company_id', companyId)
  //   .is('deal_id', null);

  let response = await service.selectByKey({
    selectKey: 'getAllKitsMilestones',
  });

  response = service.processResponse(response);

  return response?.data;
};

export default Object.assign(service, {
  createMilestone,
  getMilestoneById,
  getMilestonesByIds,
  getPreContractMilestonesByDealId,
  getUnderContractMilestonesByDealId,
  getAfterCloseMilestonesByDealId,
  getMilestonesByDealId,
  getMilestonesByDealIds,
  getAllKitsMilestones,
});
